import Box from "@mui/material/Box";
import { Pano360WebGL } from "../../../components/place360/Pano360WebGL.tsx";
import { patrolRotationDurationMs } from "./patrolRotationSpeed";

/**
 * Small 360° live preview in PiP when PTZ is main (video only — tap to swap cameras).
 */
export function PatrolPip360LivePreview({
  playlistUrl,
  streamType = "webrtc",
  autoRotate = false,
  rotationDurationSeconds,
  onTapToSwap,
}) {
  const rotationDurationMs = patrolRotationDurationMs(rotationDurationSeconds);
  const autoRotateDps =
    autoRotate && rotationDurationMs > 0 ? 360000 / rotationDurationMs : 0;

  return (
    <Box
      className={`patrol-pip-360-live${onTapToSwap ? " patrol-pip-360-live--swappable" : ""}`}
      title={onTapToSwap ? "Tap to switch camera" : undefined}
      sx={{
        position: "absolute",
        inset: 0,
        overflow: "hidden",
        bgcolor: "#000",
      }}
    >
      <Pano360WebGL
        playlistUrl={playlistUrl}
        streamType={streamType}
        enabled={Boolean(playlistUrl)}
        autoRotateDps={autoRotateDps}
        onStreamError={() => {}}
        onShortTap={onTapToSwap}
      />
    </Box>
  );
}
